import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'


@Injectable({
  providedIn: 'root'
})
export class countryService {

  stateList: State[] = [
    { stateCode: "001", stateName: "abc@gmail.com",position: 1 },
    { stateCode: "002", stateName: "abc@gmail.com", position: 2 },
    { stateCode: null, stateName: null, position: 5 }
  ];
  stateList$: BehaviorSubject<State[]> = new BehaviorSubject(this.stateList);

  documentList: Document[] = [
    { documentCode: "001", documentName: "abc@gmail.com",documentType:"abc@gmail.com",mandatory:true,position: 1 },
    { documentCode: "002", documentName: "abc@gmail.com",documentType:"abc@gmail.com",mandatory:true,position: 1 },
    { documentCode: "003", documentName: "abc@gmail.com",documentType:"abc@gmail.com",mandatory:false,position: 1 },
  ];
  documentList$: BehaviorSubject<Document[]> = new BehaviorSubject(this.documentList);

  constructor() {
  }
  newDynamic: any = {}; 

  updateState(index:number, field:string, value:number) {
    this.stateList[index][field] = value;
    this.stateList$.next(this.stateList);
  }
  removeState(index:number) {
    this.stateList.splice(index, 1);
    this.stateList$.next(this.stateList);
  }
  addState(index:number) {
    this.newDynamic = { stateCode: null, stateName: null, position:index};
    this.stateList.push(this.newDynamic);
    this.stateList$.next(this.stateList);
  }


  updateDocument(index:number, field:string, value:number) {
    this.documentList[index][field] = value;
    this.documentList$.next(this.documentList);
  }
  removeDocument(index:number) {
    this.documentList.splice(index, 1);
    this.documentList$.next(this.documentList);
  }
}

export interface State {
  stateCode: string;
  stateName: string;
  position: number;
}

export interface Document {
  documentCode: string;
  documentName: string;
  documentType: string;
  mandatory:boolean;
  position: number;
}